









































import { Component, Prop } from 'vue-property-decorator';

import ModalHeader from './header'
import Vue from 'vue';

@Component({
  components: {
    ModalHeader,
  }
})
export default class Modal extends Vue {
  @Prop({default: ''})
  title: string;

  @Prop({default: true})
  closeBtn: boolean;

  @Prop({default: false})
  logOutBtn: boolean;

  @Prop({default: ''})
  readArticleUrl: string;

  @Prop({default: 'hidden'})
  bodyOverflow: string;

  @Prop()
  bodyClass: string;

  @Prop()
  height: string

  @Prop()
  width: string

  @Prop()
  maxHeight: string

  @Prop({ default: '24px' })
  bodyPadding: string

  @Prop({ default: '10px 24px' })
  footerPadding: string

  @Prop({ default: ()=>{} })
  actionBeforeLogout: any

  mounted() {
    this.$refs.modal.focus()
  }
}


